// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-modal-page {
  padding: 30px;
  height: 100%;
  width: 100% !important;
  position: fixed;
  background: white;
}

.modal-wrapper {
  background-color: #ffffff;
  height: 20%;
}

.modal {
  background-color: white;
  border-radius: 3px;
}

.header {
  color: red;
  border-bottom: 1px solid #eaeaea;
}

.header p {
  margin: 0px;
}

.close-btn {
  float: right;
  --background: transparent;
  color: white;
  font-size: 17px;
  width: 40px;
  height: 30px;
}

.row label {
  padding-right: 15px;
  font-size: 13px;
  font-weight: bold;
}

.row input,
textarea {
  padding: 6px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 50%;
}

form.checkout {
  max-width: 500px;
  margin: 2rem auto;
  text-align: center;
  border: 2px solid #eee;
  border-radius: 8px;
  padding: 1rem 2rem;
  background: white;
  font-family: monospace;
  color: #525252;
  font-size: 1.1rem;
}

form.checkout button {
  padding: 0.5rem 1rem;
  color: white;
  background: coral;
  border: none;
  border-radius: 4px;
  margin-top: 1rem;
}

form.checkout button:active {
  background: rgb(165, 76, 43);
}

.StripeElement {
  margin: 1rem 0 1rem;
  background-color: white;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form.checkout.ng-untouched.ng-pristine.ng-valid {
  width: 100% !important;
  max-width: unset !important;
}

div#dropin-container {
  width: 100%;
}

.purchase-button {
  cursor: pointer;
  font-weight: 500;
  left: 3px;
  line-height: inherit;
  position: relative;
  text-decoration: none;
  text-align: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
}

.purchase-button--small {
  padding: 10px 20px;
  font-size: 12px;
}

.purchase-button--green {
  outline: none;
  background-color: #64d18a;
  border-color: #64d18a;
  color: white;
  transition: all 200ms ease;
  margin-bottom: 120px;
  --background: #64d18a;
}

.stripe-modal.modelWidth .modal-wrapper {
  width: 100%;
  left: 0px;
}

.stripe-modal.modelWidth .modal-wrapper .scroll-content {
  overflow: scroll;
}

.tool-bar {
  background: transparent;
  --background: transparent;
  border-bottom: 1px solid #eaeaea;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/braintree-model/braintree-model.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;;EAEE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,sBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAGA;EACE,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;EAEA,iCAAA;AAAF;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,oCAAA;AAAF;;AAGA;EACE,sBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,0BAAA;EACA,oBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,WAAA;EACA,SAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,yBAAA;EACA,gCAAA;EACA,YAAA;AAAF","sourcesContent":[".sample-modal-page {\n  padding: 30px;\n  height: 100%;\n  width: 100% !important;\n  position: fixed;\n  background: white;\n}\n\n.modal-wrapper {\n  background-color: #ffffff;\n  height: 20%;\n}\n\n.modal {\n  background-color: white;\n  border-radius: 3px;\n}\n\n.header {\n  color: red;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.header p {\n  margin: 0px;\n}\n\n.close-btn {\n  float: right;\n  --background: transparent;\n  color: white;\n  font-size: 17px;\n  width: 40px;\n  height: 30px;\n}\n\n.row label {\n  padding-right: 15px;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.row input,\ntextarea {\n  padding: 6px 12px;\n  font-size: 14px;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  width: 50%;\n}\n\nform.checkout {\n  max-width: 500px;\n  margin: 2rem auto;\n  text-align: center;\n  border: 2px solid #eee;\n  border-radius: 8px;\n  padding: 1rem 2rem;\n  background: white;\n\n  font-family: monospace;\n  color: #525252;\n  font-size: 1.1rem;\n}\n\nform.checkout button {\n  padding: 0.5rem 1rem;\n  color: white;\n  background: coral;\n  border: none;\n  border-radius: 4px;\n  margin-top: 1rem;\n}\n\nform.checkout button:active {\n  background: rgb(165, 76, 43);\n}\n\n.StripeElement {\n  margin: 1rem 0 1rem;\n  background-color: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  box-shadow: 0 1px 3px 0 #e6ebf1;\n  -webkit-transition: box-shadow 150ms ease;\n  transition: box-shadow 150ms ease;\n}\n\n.StripeElement--focus {\n  box-shadow: 0 1px 3px 0 #cfd7df;\n}\n\n.StripeElement--invalid {\n  border-color: #fa755a;\n}\n\n.StripeElement--webkit-autofill {\n  background-color: #fefde5 !important;\n}\n\nform.checkout.ng-untouched.ng-pristine.ng-valid {\n  width: 100% !important;\n  max-width: unset !important;\n}\n\ndiv#dropin-container {\n  width: 100%;\n}\n\n.purchase-button {\n  cursor: pointer;\n  font-weight: 500;\n  left: 3px;\n  line-height: inherit;\n  position: relative;\n  text-decoration: none;\n  text-align: center;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 3px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  display: inline-block;\n}\n\n.purchase-button--small {\n  padding: 10px 20px;\n  font-size: 12px;\n}\n\n.purchase-button--green {\n  outline: none;\n  background-color: #64d18a;\n  border-color: #64d18a;\n  color: white;\n  transition: all 200ms ease;\n  margin-bottom: 120px;\n  --background: #64d18a;\n}\n\n.stripe-modal.modelWidth .modal-wrapper {\n  width: 100%;\n  left: 0px;\n}\n\n.stripe-modal.modelWidth .modal-wrapper .scroll-content {\n  overflow: scroll;\n}\n\n.tool-bar {\n  background: transparent;\n  --background: transparent;\n  border-bottom: 1px solid #eaeaea;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
